import { render } from "./PostsLayer.vue?vue&type=template&id=681bf512&scoped=true"
import script from "./PostsLayer.vue?vue&type=script&lang=js"
export * from "./PostsLayer.vue?vue&type=script&lang=js"

import "./PostsLayer.vue?vue&type=style&index=0&id=681bf512&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-681bf512"]])

export default __exports__